



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETOPERATORDASHBOARDMETRICES= createAsyncThunk(
  "getOperatorDashboardMetrics/getOperatorDashboardMetrics",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getOperatorDashboardMetricsSlice = createSlice({
  name: "getOperatorDashboardMetricsSlice",
  initialState: {
    getOperatorDashboardMetrics: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetOperatorDashboardMetrics: (state) => {
        state.getOperatorDashboardMetrics.loading = false
        state.getOperatorDashboardMetrics.error = false
        state.getOperatorDashboardMetrics.data = []
        state.getOperatorDashboardMetrics.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETOPERATORDASHBOARDMETRICES.fulfilled, (state, action) => {
      state.getOperatorDashboardMetrics = {
        ...state.getOperatorDashboardMetrics,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETOPERATORDASHBOARDMETRICES.pending, (state, action) => {
      state.getOperatorDashboardMetrics = {
        ...state.getOperatorDashboardMetrics,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETOPERATORDASHBOARDMETRICES.rejected, (state, action) => {
      state.getOperatorDashboardMetrics = {
        ...state.getOperatorDashboardMetrics,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getOperatorDashboardMetricsAction = {
    GETOPERATORDASHBOARDMETRICES,
};

export { getOperatorDashboardMetricsAction };
export default getOperatorDashboardMetricsSlice.reducer;
export const {setInitialStateOfgetOperatorDashboardMetrics} = getOperatorDashboardMetricsSlice.actions
